<img 
  class="fit-to-screen"
  [src]="image.src" 
  (click)="onCloseFullImageClickHandler($event)" />
